// extracted by mini-css-extract-plugin
export default {"page":"live-module--page--LderP","section":"live-module--section--Jqob4"};